import { getItemByLabelFactory, getItemByIdFactory } from './_common'
import type { ISelectItem } from '~/types/models'

export enum LocationHardwareStatusIds {
  ACTIVE = 1,
  OUT_FOR_REPAIR = 2,
  RETIRED = 3,
}

export function getLocationHardwareStatii(): ISelectItem[] {
  return [
    { id: LocationHardwareStatusIds.ACTIVE, label: 'Active' },
    { id: LocationHardwareStatusIds.OUT_FOR_REPAIR, label: 'Out For Repair' },
    { id: LocationHardwareStatusIds.RETIRED, label: 'Retired' },
  ]
}

export const getLocationHardwareStatusByLabel = getItemByLabelFactory(
  getLocationHardwareStatii
)

export const getLocationHardwareStatusById = getItemByIdFactory(
  getLocationHardwareStatii
)
